import React, { useState, useEffect } from 'react';
import { Route, Switch } from "react-router-dom";
import '../common/css/global.css';
import './App.css';
import * as project from "../common/api/projects";
import * as impact from '../common/api/impact';
import LandingPage from "./pages/LandingPage";
import ImpactPage from "./pages/ImpactPage";

function App() {
  const merchantCode = 'MYC_NZ_RADIANCE';
  const [fetchedImpact, setfetchedImpact] = useState();
  const [projects, setProjects] = useState();

  useEffect(() => {

    if (!location?.pathname.includes('impact')) { // fetch impact projects
      project.projects(null, merchantCode, null)
        .then(response => response.json())
        .then(body => setProjects(body))
        .catch(error => {
          console.error(error);
          setProjects(error);
        })
    }

    impact.merchants(merchantCode, null) // fetch impact
      .then(response => response.json())
      .then(body => {
        setfetchedImpact(body)
      })
      .catch(error => {
        console.error(error);
        setfetchedImpact(error)
      })
  }, []);

  return (
    <>

      <Switch>
      <Route
          exact
          path={`/impact`}
          key="app-RADIANCE-learnmore"
        >
          <ImpactPage merchantCode={merchantCode} />
        </Route>
        <Route
          path={`/`}
          key="app-RADIANCE-landing"
        >
          <LandingPage fetchedImpact={fetchedImpact} merchantCode={merchantCode} />
        </Route>
      </Switch>
    </>
  );
}

export default App;
